import { render, staticRenderFns } from "./ContasBancariasCadastrar.vue?vue&type=template&id=643eb704"
import script from "./ContasBancariasCadastrar.vue?vue&type=script&lang=js"
export * from "./ContasBancariasCadastrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports